import { useLocalStorage } from "../../hooks/useLocalStorage";

import { FormField } from "../../types/forms";

interface MarketingDetailsSectionProps {
  userId: string;
  templateId: string;
  readOnly?: boolean;
  fields?: FormField[];
  value?: Record<string, boolean>;
  onChange?: (value: Record<string, boolean>) => void;
}

interface Preferences {
  smsOptIn: boolean;
  emailOptIn: boolean;
}

export default function MarketingDetailsSection({
  userId,
  templateId,
  readOnly = false,
  fields,
  value,
  onChange,
}: MarketingDetailsSectionProps) {
  const storageKey = `${userId}_${templateId}_marketing`;

  const [preferences, setPreferences] = useLocalStorage<Preferences>(storageKey, {
    smsOptIn: false,
    emailOptIn: false,
  });

  const handleChange = (key: keyof Preferences) => {
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="space-y-3">
      <h2 className="text-xl font-semibold text-gray-800">Marketing Details</h2>

      <p className="text-sm font-medium text-gray-700">Communication Preferences</p>

      <div className="space-y-2">
        {fields && fields.length > 0 ? (
          fields.map((f) => (
            <label key={f.id} className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={!!value?.[String(f.id)]}
                onChange={() => {
                  if (!readOnly && onChange) {
                    onChange({ ...value, [String(f.id)]: !value?.[String(f.id)] });
                  }
                }}
                className="accent-[#885ABB] w-4 h-4 cursor-pointer disabled:cursor-not-allowed"
                disabled={readOnly}
              />
              {f.label}
            </label>
          ))
        ) : (
          <>
            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={value?.["SMS Opt In"] ?? preferences.smsOptIn}
                onChange={() => {
                  if (readOnly) return;
                  if (onChange) {
                    onChange({ ...value, ["SMS Opt In"]: !(value?.["SMS Opt In"] ?? preferences.smsOptIn) });
                  } else {
                    handleChange("smsOptIn");
                  }
                }}
                className="accent-[#885ABB] w-4 h-4 cursor-pointer disabled:cursor-not-allowed"
                disabled={readOnly}
              />
              SMS Opt In
            </label>

            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={value?.["Email Opt In"] ?? preferences.emailOptIn}
                onChange={() => {
                  if (readOnly) return;
                  if (onChange) {
                    onChange({ ...value, ["Email Opt In"]: !(value?.["Email Opt In"] ?? preferences.emailOptIn) });
                  } else {
                    handleChange("emailOptIn");
                  }
                }}
                className="accent-[#885ABB] w-4 h-4 cursor-pointer disabled:cursor-not-allowed"
                disabled={readOnly}
              />
              Email Opt In
            </label>
          </>
        )}
      </div>
    </div>
  );
}
